import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { SeguimientoPanel } from './SeguimientoPanel';

// Diálogo rápido de seguimiento de un prospecto, abierto desde la lista.
export const SeguimientoDialog = ({ open, onOpenChange, patient, onChange, onCitaAgendada }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            Seguimiento — {patient?.nombre} {patient?.apellido}
          </DialogTitle>
        </DialogHeader>
        {patient && <SeguimientoPanel patient={patient} onChange={onChange} onCitaAgendada={onCitaAgendada} />}
      </DialogContent>
    </Dialog>
  );
};
